type CompetitionLabel = {
  displayName: string;
  autonomousCommunity?: { name?: string | null } | null;
};

export const formatCompetitionLabel = ({ displayName, autonomousCommunity }: CompetitionLabel) =>
  autonomousCommunity?.name ? `${displayName} (${autonomousCommunity.name})` : displayName;
